import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightDownCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.2853 10.0174C10.2607 10.076 10.2247 10.1307 10.1767 10.1787C10.1287 10.2267 10.0733 10.2634 10.014 10.288C9.95535 10.312 9.89135 10.3254 9.82402 10.3254H9.82002L6.97202 10.3194C6.69602 10.3187 6.47202 10.0947 6.47268 9.81869C6.47335 9.54269 6.69735 9.31935 6.97268 9.31935H6.97402L8.61402 9.32269L5.82068 6.53002C5.62535 6.33469 5.62535 6.01802 5.82068 5.82269C6.01602 5.62735 6.33268 5.62735 6.52802 5.82269L9.32135 8.61602L9.31868 6.97335C9.31868 6.69735 9.54202 6.47335 9.81802 6.47269C10.094 6.47269 10.3187 6.69602 10.3187 6.97202L10.3233 9.82469C10.3233 9.89269 10.31 9.95802 10.2853 10.0174ZM12.4773 3.52202C11.2813 2.32535 9.69068 1.66669 7.99935 1.66669C6.30735 1.66669 4.71668 2.32535 3.52135 3.52202C2.32468 4.71802 1.66602 6.30869 1.66602 8.00069C1.66602 9.69202 2.32468 11.282 3.52135 12.478C4.71668 13.6747 6.30735 14.3334 7.99935 14.3334C9.69068 14.3334 11.2813 13.6747 12.4773 12.478C13.674 11.2827 14.3327 9.69202 14.3327 8.00069C14.3327 6.30869 13.674 4.71802 12.4773 3.52202Z",
		fill: "currentColor"
	})
});
export default SvgRightDownCircleFill;
